import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiCrowdRemoveBadgesRequestBody,
  IApiCrowdRemoveBadgesResponseBody,
} from '../CrowdApi.types';
import { useApi } from '~/lib/api/useApi';
import { userBadgesQueryKeyFactory } from '../../UserBadges/hooks/useUserBadgesQuery';

export type IUseRemoveBadgesCrowdMutationValues = {
  appId: string;
  body: IApiCrowdRemoveBadgesRequestBody;
};

export const useRemoveBadgesCrowdMutation = (): UseMutationResult<
  IApiCrowdRemoveBadgesResponseBody,
  unknown,
  IUseRemoveBadgesCrowdMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values) => api.crowd.removeBadges(values.appId, values.body),
    onSuccess: async (_data, values) => {
      await queryClient.invalidateQueries({
        queryKey: userBadgesQueryKeyFactory({ appId: values.appId }),
      });
    },
  });
};
